import { cn } from "@theprelude/core";

export const GoogleIdentityIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5734 9.68584C11.8554 11.7947 8.33782 9.03475 10.2997 6.74442C12.0273 4.72777 15.5411 7.27163 13.5734 9.68584Z" />
    <path d="M16.0913 13.2708C15.0883 14.3354 13.6655 15 12.0874 15C10.4734 15 9.02175 14.3048 8.01562 13.1975C10.2092 11.0789 13.9081 11.0948 16.0913 13.2708Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4815 2.07484C18.3705 2.03908 18.2685 2.00625 18.1914 1.98323C16.1162 1.36767 14.0352 0.754992 11.9379 0.213379C10.6197 0.65036 9.24941 1.01187 7.87907 1.37338C6.34939 1.77693 4.81968 2.18049 3.36237 2.68905C3.32066 2.70366 3.26741 2.71938 3.20835 2.73682C2.97232 2.80651 2.64347 2.90361 2.5874 3.06645C2.60981 3.92049 2.6106 4.79029 2.6114 5.66683C2.61389 8.39667 2.61644 11.1919 3.2721 13.7796C4.194 17.4192 6.36141 20.7361 9.45648 22.8641C9.91935 23.183 11.6441 24.2844 12.1021 24.2095C12.6697 24.1164 14.2724 23.0572 14.7996 22.673C19.9133 18.9499 21.2087 13.7163 21.3979 7.6644C21.4225 6.88114 21.4103 6.0957 21.3981 5.31014C21.3861 4.52967 21.374 3.74909 21.3979 2.97042C20.8309 2.74294 20.2376 2.5797 19.6456 2.41681C19.3904 2.34659 19.1354 2.27643 18.8829 2.20122C18.7535 2.16241 18.6113 2.11663 18.4815 2.07484ZM12.0874 16.2134C15.4011 16.2134 18.0874 13.5271 18.0874 10.2134C18.0874 6.89967 15.4011 4.21338 12.0874 4.21338C8.77369 4.21338 6.0874 6.89967 6.0874 10.2134C6.0874 13.5271 8.77369 16.2134 12.0874 16.2134Z"
    />
  </svg>
);
